import React from 'react';
import PropTypes from 'prop-types';
import { get, getOr, map, flatten, flow } from 'lodash/fp';
import MoveTo from 'moveto';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Slugify, SanitizeHtml } from '@bd/bdcore-utilities';
import RouteCollection from '@bd/bdcore-named-routes';
import YoutubeThumbnail from '@bd/bdui-youtubethumbnail';

import Header from '../../components/Header';
import InsideHeader from '../../components/InsideHeader';
import Footer from '../../components/Footer';
import PageHelmet from '../../components/PageHelmet';
import MenuWhy from '../../components/MenuWhy';
import MenuVideoCategories from './MenuVideoCategories';
import { colors } from '../../styles';

const styles = css`
  .VideoGallery_wrapper {
    padding: 30px 0 120px;

    .embed-responsive {
      margin: 0 auto;
      max-width: 100% !important;
      @media(min-width: 992px) {
        max-width: 66.666667% !important;
      }
    }
  }
  .VideoGallery_menuHeading {
    display: none;
    @media (min-width: 992px) {
      display: block;
      font-weight: 700;
      font-size: 21px;
      color: #000000;
      padding: 20px;
      background-color: ${colors.neutral};
      margin: 0 30px 0 0;
    }
  }
  .VideoGallery_videoTitle {
    font-weight: 800;
    font-size: 23px;
    color: ${colors.brand1};
    text-transform: uppercase;
    line-height: 36px;
    position: relative;
    margin: 0 0 60px 0;
    text-align: center;
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -20px;
      display: block;
      width: 125px;
      height: 3px;
      background-color: ${colors.brand2};
    }
  }

  .Video_overlay {
    position: absolute !important;
    width: 100%;
    height: 100%;
    background-color: rgba(51,51,51,0.4);
    color: rgba(60, 157, 199, 0.85);
    top: 0;
    margin: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    transition: all .3s ease-out;
    cursor: pointer;
    &:hover {
      background-color: rgba(43, 102, 144, 0.6);
      color: rgba(43, 102, 144, 5.4);
      transition: all .3s ease-out;

      img {
        opacity: .8;
        transition: all .3s ease-out;
      }
    }

    img {
      width: 80px;
      height: 65px;
      transition: all .3s ease-out;
    }
  }

  .VideoGallery_videoThumb {
    position: relative;
  }

  .VideoActive_wrapper {
    ${'' /* display: flex;
    flex-direction: column; */}

    .VideoTitle_wrapper {
      order: 1;
      @media(min-width: 992px) {
        order: unset;
      }
    }

  }
`;

function addAutoPlay(video) {
  const beforeParam = (video.match(/src="(.*\?.*?)"/))
    ? '&'
    : '?';
  const newVideo = video.replace(/src="(.*youtube\.com.*?)"/, `src="$1${beforeParam}autoplay=1"`);
  return newVideo;
}

function scrollToRef(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 250,
    });
    moveTo.move(ref);
  }, 100);
}

class VideoGallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeVideo: null,
    };
  }

  setActiveVideo = activeVideo => {
    this.setState({
      activeVideo: {
        ...activeVideo,
        embed_code: addAutoPlay(activeVideo.embed_code),
      },
    });

    scrollToRef(this.videoRef);
  }

  setVideoRef = ref => {
    this.videoRef = ref;
  }

  render() {
    const { page, router } = this.props;
    let { activeVideo } = this.state;

    const route = RouteCollection.getRouteByPath(get('location.pathname', router));
    const gallerySlug = get('params.gallery', route);
    let activeGallery;
    let videos = [];

    if (gallerySlug) {
      activeGallery = getOr([], 'video_section', page)
        .find(g => Slugify(getOr('', 'category', g)) === gallerySlug);
      videos = getOr([], 'videos', activeGallery);
    } else {
      videos = flow(
        map('videos'),
        flatten,
      )(getOr([], 'video_section', page));
    }

    if (!activeVideo) {
      [activeVideo] = videos;
    }

    return (
      <div className={styles}>
        <PageHelmet page={page} />
        <Header />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get('page_image.contentUrl', page)}
          p={'Inspiration Starts Here'}
        />
        <MenuWhy />
        <MenuVideoCategories
          page={page}
        />


        <div className="container VideoGallery_wrapper">
          {
            activeVideo &&
            <div ref={ref => this.setVideoRef(ref)} className="VideoActive_wrapper">
              <div className="VideoTitle_wrapper">
                <h2 className="VideoGallery_videoTitle">
                  {get('title', activeVideo)}
                </h2>
              </div>
              <div
                className="col-8 embed-responsive embed-responsive-16by9 mb-5"
                dangerouslySetInnerHTML={SanitizeHtml(get('embed_code', activeVideo))}
              />
            </div>
          }
          <div className="row">
            {
              videos.map(video => (
                <div className="col-lg-4 mb-4" key={get('title', video)}>
                  <div className="VideoGallery_videoThumb">
                    <YoutubeThumbnail
                      video={get('embed_code', video)}
                    />
                    <span className="Video_overlay" role="button" tabIndex="0" onClick={() => this.setActiveVideo(video)}>
                      <img src="/images/icon-play.svg" alt="Play Icon" />
                    </span>
                  </div>
                  <h5>{video.title}</h5>
                </div>
              ))
            }
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

VideoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  page: 'video_gallery',
  router: true,
})(VideoGallery);



// WEBPACK FOOTER //
// ./src/pages/VideoGallery/index.js